import { render } from "./tab-booking-success.vue?vue&type=template&id=7edbb384&scoped=true&ts=true"
import script from "./tab-booking-success.vue?vue&type=script&lang=ts"
export * from "./tab-booking-success.vue?vue&type=script&lang=ts"

import "./tab-booking-success.vue?vue&type=style&index=0&id=7edbb384&scoped=true&lang=css"
import "./tab-booking-success.vue?vue&type=style&index=1&id=7edbb384&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7edbb384"]])

export default __exports__